var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14",
    id: "Download-File--Streamline-Core",
    height: 14,
    width: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Download File Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "download-file"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fill: "#4891ff",
    fillRule: "evenodd",
    d: "M1.44 0.44A1.5 1.5 0 0 1 2.5 0h6a0.5 0.5 0 0 1 0.354 0.146l4 4A0.5 0.5 0 0 1 13 4.5v8a1.5 1.5 0 0 1 -1.5 1.5h-9A1.5 1.5 0 0 1 1 12.5v-11c0 -0.398 0.158 -0.78 0.44 -1.06Zm5.747 10.502 0.104 -0.104c0.116 -0.076 0.216 -0.176 0.292 -0.292l1.854 -1.854a0.625 0.625 0 0 0 -0.442 -1.067h-1.25V4a1 1 0 0 0 -2 0v3.625h-1.25a0.625 0.625 0 0 0 -0.442 1.067l1.854 1.854c0.076 0.116 0.176 0.216 0.292 0.292l0.104 0.104a0.625 0.625 0 0 0 0.884 0Z",
    clipRule: "evenodd",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/file-icon.115f7f44da50f3fd84d285af0a20bd31.svg";
export { ForwardRef as ReactComponent };